import React from "react";
import { getTemplate, labelValue, } from "@rjsf/utils";
export default function RangeWidget(props) {
    const { value, label, hideLabel, options, registry } = props;
    const BaseInputTemplate = getTemplate("BaseInputTemplate", registry, options);
    return (React.createElement(BaseInputTemplate, { ...props, extraProps: { label: labelValue(label || undefined, hideLabel) } },
        React.createElement("span", { className: "range-view" }, value)));
}
//# sourceMappingURL=RangeWidget.js.map